module.exports = __webpack_public_path__ + "static/media/marker_Midblock.5ba75e30.svg";